module.exports = __webpack_public_path__ + "static/media/loader_alternative.b409e599.gif";